import { DeepPartial, Theme } from '@fanadise/common-types';
import { merge } from '@fanadise/common-utils';
import { DEFAULT_THEME } from 'consts/defaultTheme';

export const mergeTheme = (
  partialTheme: DeepPartial<Theme>,
  fullTheme: Theme = DEFAULT_THEME,
): Required<Theme> => merge(fullTheme, partialTheme);
